module.exports = __webpack_public_path__ + "img/coach-slide5.3af16cfc.png";